import $ from 'jquery';

class ImageGradientController {
    constructor(elem) {
        this.element = elem;
        this.prepareLinks();
    }

    prepareLinks() {
        if (this.element.classList.contains('no-button')) this.addLinksToGradientCaptions();
        else this.registerButtonVisibilityEvents();
    }

    registerButtonVisibilityEvents() {
        $(this.element).hover(
            () => {
                $(this.element).find('.btn').show();
            },
            () => {
                $(this.element).find('.btn').hide();
            },
        );
    }

    addLinksToGradientCaptions() {
        const url = $(this.element).data('url');
        if (url === '') return;
        const target = $(this.element).data('target');
        const anchorTag = `<a href='${url}' target='${target}'></a>`;
        $(this.element).wrap(anchorTag);
    }

    static init() {
        $(document).ready(() => {
            $('.image-with-gradient-caption').each((index, value) => {
                new ImageGradientController(value); // eslint-disable-line no-new
            });
        });
    }
}

window.ImageGradientController = ImageGradientController;
export default ImageGradientController;
